import type { ReactNode } from 'react';
import { countryName, flagOf } from '../lib/country.js';

/** A country as a flag, its code and (when asked) its name. Nothing known reads as a dash. */
export function Flag({
  code,
  name = false,
}: {
  code: string | null | undefined;
  name?: boolean;
}): ReactNode {
  if (code === null || code === undefined || code === '') {
    return (
      <span className="muted" title="No database placed this address">
        —
      </span>
    );
  }
  return (
    <span className="flag" title={countryName(code)}>
      <span className="flag-glyph" aria-hidden="true">
        {flagOf(code)}
      </span>
      <span className="flag-code">{name ? countryName(code) : code}</span>
    </span>
  );
}
